import dynamic from "next/dynamic";
const ExpandableProductsPricingComponent = dynamic(()=>import("./expandable-products-pricing-component"));
import ExpandableProductsPricingConfig from "./expandable-products-pricing-config";
import ExpandableProductsPricingAdvancedConfig from "./expandable-products-pricing-advanced-config";
export default {
    ExpandableProductsPricingComponent,
    ExpandableProductsPricingConfig,
    ExpandableProductsPricingAdvancedConfig
};
